// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__2iva1","svg":"loading_svg__E8f1g","circle":"loading_circle__NO66U","rotate":"loading_rotate__rvLVd"};